"use client";

import Pagination from "@/components/ui/Pagination";
import { useBlogs } from "@/hooks/usePublicData";
import { useLocale } from "next-intl";
import { useState } from "react";
import BlogCard from "./BlogCard";

function Icon({ name, className = "" }: { name: string; className?: string }) {
  return <span className={`material-symbols-outlined ${className}`}>{name}</span>;
}

export default function BlogClient() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const t = (a: string, e: string) => (isAr ? a : e);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const { data, isLoading } = useBlogs({ page, limit: 9, search: search.trim() || undefined });
  const blogs = data?.data ?? [];

  const onSearch = (v: string) => {
    setSearch(v);
    setPage(1);
  };

  return (
    <div className="najdi bg-background text-ink-900 min-h-screen" dir={isAr ? "rtl" : "ltr"}>
      {/* Hero */}
      <section className="bg-clay-50 najdi-pattern">
        <div className="container mx-auto px-6 py-14 md:py-20 text-center">
          <h1 className="font-display text-3xl md:text-5xl font-extrabold text-ink-900 mb-3">{t("مدوّنة منازل الدرعية", "Diriyah Homes Blog")}</h1>
          <p className="text-ink-500 max-w-xl mx-auto mb-8">
            {t("نصائح ومقالات وقصص عن الإقامة والتجارب والحياة في الدرعية.", "Tips, articles and stories about stays, experiences and life in Diriyah.")}
          </p>
          <div className="max-w-md mx-auto relative">
            <span className="absolute top-1/2 -translate-y-1/2 inset-s-4 text-ink-500"><Icon name="search" /></span>
            <input
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder={t("ابحث في المقالات…", "Search articles…")}
              className="w-full rounded-full bg-surface text-ink-900 ps-12 pe-4 py-3.5 outline-none border border-clay-100 focus:border-clay-600 placeholder:text-ink-500"
            />
          </div>
        </div>
      </section>

      <main className="container mx-auto px-6 py-12 min-h-[40vh]">
        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-80 rounded-2xl bg-clay-100/40 animate-pulse" />)}
          </div>
        ) : blogs.length === 0 ? (
          <div className="flex flex-col items-center justify-center gap-3 py-24 text-center">
            <Icon name="article" className="text-ink-500 text-5xl" />
            <p className="text-ink-500 font-bold">{t("لا توجد مقالات بعد", "No articles yet")}</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {blogs.map((b) => <BlogCard key={b.id || b._id} blog={b} locale={locale} isAr={isAr} />)}
            </div>
            <Pagination page={page} totalPages={data?.pagination?.totalPages ?? 0} onChange={setPage} isAr={isAr} />
          </>
        )}
      </main>
    </div>
  );
}
